// extracted by mini-css-extract-plugin
export default {"edit_button":"EditButton_edit_button__CkTnF"};